/**
 * Created by anthony on 11/19/14.
 */

stateProviders.push({
    name: 'schoolside.archives',
    url: '/archive',
    templateUrl: 'fast/submodules/schoolside/archive/partials/archive.html?v=' + versionNo,
    controller: "ArchiveController",
    resolve :
    {
        bins: function(BinFactory)
        {
            return BinFactory.retrieveData(true);
        },
        schoolSubcategories: function(SchoolSubcategoriesModelService, authServiceFactory)
        {
            return SchoolSubcategoriesModelService.get(authServiceFactory.getAuth().schoolID);
        },
        account: function(AccountModelService, authServiceFactory)
        {
            return AccountModelService.get(authServiceFactory.getAuth().schoolID);
        },
        thresh: function(SchoolModelService, authServiceFactory)
        {
            SchoolModelService.get(authServiceFactory.getAuth().schoolID);
        },
        archiveYears:function(ArchiveYearsService, authServiceFactory)
        {
            return ArchiveYearsService.get(authServiceFactory.getAuth().schoolID)
        }
    }

});

stateProviders.push({
    name: 'schoolside.archive',
    url: '/archive/:applicationID',
    templateUrl: 'fast/submodules/schoolside/archive/partials/archive.html?v=' + versionNo,
    controller: "ApplicationsController",
    resolve :
    {
        bins: function(BinFactory)
        {
            return BinFactory.retrieveData(true);
        },
        schoolSubcategories: function(SchoolSubcategoriesModelService, authServiceFactory)
        {
            return SchoolSubcategoriesModelService.get(authServiceFactory.getAuth().schoolID);
        },
        account: function(AccountModelService, authServiceFactory)
        {
            return AccountModelService.get(authServiceFactory.getAuth().schoolID);
        },
        thresh: function(SchoolModelService, authServiceFactory)
        {
            SchoolModelService.get(authServiceFactory.getAuth().schoolID);
        }
    }

});

